import Cookies from 'js-cookie'
import {getUrlKey} from '@/utils/index'

//获取浏览器的语言
function navigatorLanguage() {
  const JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
  let language = ''
  if (JsSrc == 'zh-cn') {// 中文
    language = 'zh'
  } else if (JsSrc == 'en') {// 英文
    language = 'en'
  } else if (JsSrc == 'ko') { // 韩文
    language = 'ko'
  } else if (JsSrc == 'zh-tw') {// 繁体
    language = 'zh_ft'
  } else {
    language = 'en'
  }
  return language
}

let lang = getUrlKey('lang')  /*浏览器地址栏如果有语言配置这读取并设置全局多语言*/
if (lang == "null" || lang == null || lang == undefined) {

} else {
  if (lang == 'zh' || lang == 'en' || lang == 'ko' || lang == 'zh_ft') {
    Cookies.set('language', lang)
  }
}

function getLang() {
  let lang = getUrlKey('lang')
  if (lang == "null" || lang == null || lang == undefined) {
    return Cookies.get('language') || navigatorLanguage()
  } else {
    if (lang == 'zh') {
      Cookies.set('language', 'zh')
    } else if (lang == 'en') {
      Cookies.set('language', 'en')
    } else if (lang == 'ko') {
      Cookies.set('language', 'ko')
    } else if (lang == 'zh_ft') {
      Cookies.set('language', 'zh_ft')
    } else {
      Cookies.set('language', 'en')
    }
    return Cookies.get('language')
  }
}

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: getLang()
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    }
  },
  actions: {
    toggleSideBar({commit}) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({commit}, {withoutAnimation}) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({commit}, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({commit}, language) {
      commit('SET_LANGUAGE', language)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js